<section class="flex-column full-height">
  <vdw-header [title]="'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'GENERAL.UNIT.UNIT' | bmsTranslate | lowercase}" svgIcon="select-blue"> </vdw-header>
  <article class="dialog-content full-height flex-column gap-16">
    @if (!getIsCatalog()) {
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.CREATE_NEW' | bmsTranslate" (click)="navigateToAddUnit()">
        <mat-icon svgIcon="add"></mat-icon>
      </button>
    }
    <ag-grid-angular #unitsGrid class="ag-theme-vdw" [gridOptions]="gridOptionsForListOfUnits" [rowData]="listOfUnits"> </ag-grid-angular>
  </article>
  <vdw-footer [locked]="!canSelectUnit()" [centered]="true" (chooseEvent)="selectUnit()"></vdw-footer>
</section>
